/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - David Pistori <dp@indigen.com>
 *   - Loay Hatem <lh@indigen.com>
 *   - Peter Magdy <pm@indigen.com>
 * NOTICE: All information contained here is, and remains
 * the property of Indigen Solutions and its suppliers, if any.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import * as React from "react";

const RedLem: any = (props: {}) => {
  return (
    <svg width="125" height="236" viewBox="0 0 125 236" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5684 77.5947C68.0481 77.5947 104 106.623 104 156.797C104 203.299 66.4438 236 18.5684 236C-31.3719 236 -64.4095 203.55 -66.8821 152.052C-69.0262 107.25 -42.3077 29.3695 43.66 0L47.957 8.55448C25.1631 24.3059 7.52313 49.0328 5.18272 64.8533C3.00713 79.5673 14.6337 77.5947 18.5684 77.5947"
        fill="#E30613"
      />
      <path
        d="M63.4176 48H124.963C111.189 95.7941 93.8999 141.225 78.5136 188.243H33C43.322 141.119 53.2892 94.877 63.4176 48Z"
        fill="#FFE5B5"
      />
    </svg>
  );
};

export default RedLem;
